import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { deleteTransaction } from "../api";
import { ErrorResponse } from "./useCreateTransaction";

export const useDeleteTransaction = () => {
  const router = useNavigate();
  const queryClient = useQueryClient();
  const { mutate, isPending } = useMutation({
    mutationFn: deleteTransaction,
    onSuccess() {
      queryClient.refetchQueries({ queryKey: ["TRANSACTION"] });
      router("/order-list");
      toast.success("Success Delete Transaction");
    },
    onError: (error: ErrorResponse) => {
      const message =
        error?.response?.data?.message || "Failed to create transaction";
      toast.error(message);
    },
  });

  return { Delete: mutate, isPending };
};
